import { useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import {
    IsEmailExist,
    isMobileExist,
    loginUser,
    VerifyOtp,
} from "../services/authService";

const Login = () => {
    const navigate = useNavigate();
    const [checkingUser, setCheckingUser] = useState(false);
    const [formData, setFormData] = useState({
        loginId: "",
        password: "",
    });

    const [errors, setErrors] = useState({});
    const [showOtpField, setShowOtpField] = useState(false);
    const [otp, setOtp] = useState("");
    const [otpVerified, setOtpVerified] = useState(false);
const [sendingOtp, setSendingOtp] = useState(false);
    const [showPasswordField, setShowPasswordField] = useState(false);
const [verifyingOtp, setVerifyingOtp] = useState(false);
    // ---------------- Validation ----------------

    const isValidMobile = (value) => /^[6-9]\d{9}$/.test(value);

    const isValidEmail = (value) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    // ---------------- Handle Change ----------------

    const handleChange = async (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Password
        if (name === "password") {
            setErrors((prev) => ({
                ...prev,
                password: "",
                auth: "",
            }));
            return;
        }

        if (name !== "loginId") return;

        setErrors({});
        setShowPasswordField(false);

        const input = value.trim();

        if (!input) {
            setErrors({
                loginId: "Mobile number or Email is required",
            });
            return;
        }

        const mobile = isValidMobile(input);
        const email = isValidEmail(input);

        if (!mobile && !email) {
            setErrors({
                loginId: "Enter a valid mobile number or email",
            });
            return;
        }
        setCheckingUser(true);
        try {
            let response;

            if (mobile) {
                response = await isMobileExist(input);
            } else {
                response = await IsEmailExist(input);
            }

            if (
                response?.statusCode === 200 &&
                response?.success === true
            ) {
                if(response?.data.isOTPEnable===true)
                {
                setShowOtpField(true);
                }
                else{
                setShowPasswordField(true);
                }
            } else {
                setShowOtpField(false);
                setShowPasswordField(false);

                setErrors({
                    loginId: mobile
                        ? "Mobile number not registered"
                        : "Email not registered",
                });
            }
        } catch (error) {
            console.log(error);

            setShowPasswordField(false);

            setErrors({
                loginId: "Something went wrong",
            });
        } finally {
            setCheckingUser(false);
        }
    };

    // ---------------- Login ----------------
    const handleSendOtp = async () => {
    try {
        setSendingOtp(true);

        const payload = {
            mobile: formData.loginId
        };

        const response = await IsEmailExist(payload);
        if (response.statusCode === 200) {
            setShowOtpField(true);

            setErrors((prev) => ({
                ...prev,
                otp: ""
            }));
        } else {
            setErrors((prev) => ({
                ...prev,
                otp: response.message
            }));
        }
    }
    catch (err) {
        setErrors((prev) => ({
            ...prev,
            otp: "Unable to send OTP"
        }));
    }
    finally {
        setSendingOtp(false);
    }
};
const handleVerifyOtp = async () => {

    if (!otp.trim()) {
        setErrors((prev) => ({
            ...prev,
            otp: "OTP is required"
        }));
        return;
    }

    try {

        setVerifyingOtp(true);

        const payload = {
            email: formData.loginId,
            otp: otp
        };

        const response = await VerifyOtp(payload);
console.log("VerifyOtp", response);
        if (response.statusCode === 200) {

            setOtpVerified(true);
 setShowPasswordField(true);
            setErrors((prev) => ({
                ...prev,
                otp: ""
            }));

            alert("OTP Verified Successfully");

            // Navigate or login here

        } else {

            setOtpVerified(false);
 setShowPasswordField(false);
            setErrors((prev) => ({
                ...prev,
                otp: "Invalid OTP"
            }));
        }

    } catch {

        setErrors((prev) => ({
            ...prev,
            otp: "OTP Verification Failed"
        }));

    } finally {

        setVerifyingOtp(false);
    }
};
    const handleSubmit = async (e) => {
        e.preventDefault();

        const { loginId, password } = formData;

        let validationErrors = {};

        if (!loginId.trim()) {
            validationErrors.loginId =
                "Mobile number or Email is required";
        } else if (
            !isValidMobile(loginId) &&
            !isValidEmail(loginId)
        ) {
            validationErrors.loginId =
                "Enter a valid mobile number or email";
        }

        if (!password.trim()) {
            validationErrors.password =
                "Password is required";
        }

        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0)
            return;

        try {
            const payload = {
                Mobile: formData.loginId,
                password: formData.password,
            };

            const response = await loginUser(payload);

            console.log("Login", response);

            if (response.statusCode === 200) {
                localStorage.setItem(
                    "userid",
                    response.data.data.id
                );

                localStorage.setItem(
                    "username",
                    response.data.data.username
                );

                localStorage.setItem(
                    "roleid",
                    response.data.data.uRoles[0].id
                );

                localStorage.setItem(
                    "rolename",
                    response.data.data.uRoles[0].roleName
                );

                localStorage.setItem(
                    "userPermissionRoleId",
                    response.data.data.userPermissionRoleId
                );
                localStorage.setItem(
                    "salesPunchRoleId",
                    response.data.data.salesPunchRoleId
                );

                navigate("/dashboard");
            } else {
                setErrors({
                    auth:
                        response.message ||
                        "Invalid login credentials",
                });
            }
        } catch (error) {
            console.log(error);

            setErrors({
                auth:
                    error.response?.data?.message ||
                    error.message ||
                    "Something went wrong",
            });
        }
    };

    // ---------------- Button ----------------

    const isButtonDisabled =
        !showPasswordField ||
        !formData.loginId.trim() ||
        !formData.password.trim() ||
        !!errors.loginId ||
        !!errors.password;

    return (
        <>
            <Helmet>
                <title>Login Page</title>
            </Helmet>

            <div
                className="d-flex justify-content-center align-items-center vh-100"
                style={{ backgroundColor: "#d7d9e0" }}
            >
                <div
                    className="bg-white p-4 text-center shadow"
                    style={{ width: "560px" }}
                >
                    <div className="mb-4">
                        <h1
                            className="fw-bold"
                            style={{
                                fontSize: "52px",
                                color: "#4a4a4a",
                            }}
                        >
                            Ayurmax{" "}
                            <span style={{ color: "#69b300" }}>
                                Life
                            </span>
                        </h1>

                        <p
                            className="d-inline-block text-white px-3 py-1 mt-2"
                            style={{
                                backgroundColor: "#69b300",
                                fontSize: "18px",
                            }}
                        >
                            Healthcare that Cares
                        </p>
                    </div>

                    <div
                        className="mb-4"
                        style={{
                            color: "#555",
                            fontSize: "18px",
                        }}
                    >
                        Sign in to start your session
                    </div>

                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="mb-3 position-relative">
    <input
        type="text"
        className="form-control py-3 pe-5"
        name="loginId"
        placeholder="Enter Mobile Number or Email"
        value={formData.loginId}
        onChange={handleChange}
        autoComplete="off"
    />

    {checkingUser && (
        <div
            className="spinner-border spinner-border-sm text-primary position-absolute"
            role="status"
            style={{
                width: "20px",
                height: "20px",
                top: "50%",
                right: "15px",
                transform: "translateY(-50%)",
                zIndex: 10,
            }}
        >
            <span className="visually-hidden">Loading...</span>
        </div>
    )}

    {errors.loginId && (
        <p className="text-danger text-start mt-1 mb-0">
            {errors.loginId}
        </p>
    )}
</div>
{showOtpField && (
    <div className="mb-3">

        <input
            type="text"
            className="form-control"
            placeholder="Enter OTP"
            value={otp}
            maxLength={6}
            onChange={(e) =>
        setOtp(e.target.value.replace(/\D/g, ""))
    }
        />

        {errors.otp && (
            <p className="text-danger mt-1">
                {errors.otp}
            </p>
        )}

    </div>
)}

{showOtpField && !otpVerified && (
    <>
<button
    type="button"
    className="btn btn-success mb-3"
    onClick={handleSendOtp}
    disabled={sendingOtp}
>
    {sendingOtp ? "Sending..." : "Send OTP"}
</button>
<button
    type="button"
    className="btn btn-primary mb-3"
    onClick={handleVerifyOtp}
    disabled={verifyingOtp || otp.length !== 6}
>
    {verifyingOtp ? "Verifying..." : "Verify OTP"}
</button>
</>
)}
                        {showPasswordField && (
                            <div className="mb-3 position-relative">
                                <input
                                    type="password"
                                    className="form-control py-3 pe-5"
                                    name="password"
                                    placeholder="Enter Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />

                                <i className="fa-solid fa-lock position-absolute top-50 end-0 translate-middle-y me-3 text-secondary"></i>

                                {errors.password && (
                                    <p className="text-danger text-start mt-1 mb-0">
                                        {errors.password}
                                    </p>
                                )}

                                {errors.auth && (
                                    <p className="text-danger text-start mt-1 mb-0">
                                        {errors.auth}
                                    </p>
                                )}
                            </div>
                        )}

                        <div className="d-flex justify-content-between align-items-center">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="rememberMe"
                                    defaultChecked
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor="rememberMe"
                                >
                                    Remember Me
                                </label>
                            </div>

                            <button
                                type="submit"
                                disabled={isButtonDisabled}
                                className="btn text-white px-4 py-2"
                                style={{
                                    backgroundColor:
                                        isButtonDisabled
                                            ? "#9aa0a6"
                                            : "#3c8dbc",
                                    cursor:
                                        isButtonDisabled
                                            ? "not-allowed"
                                            : "pointer",
                                }}
                            >
                                Sign in
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Login;